import React from 'react';
import { object, string } from 'yup';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

import { env } from '~/commons/config';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FormResource from './FormResource.jsx';
import FieldsCompPicker from './competition/FieldsCompPicker.jsx';

const defaults = {
  active: true,
  username: '',
  password: '',
  studentId: '',
  name: { full: { en: '', zhhk: '' } },
  schoolClass: {
    title: '',
    grade: '',
  },
  competition: '',
};

const FormStudent = ({
  school,
  student,
}) => (
  <FormResource
    {...{
      defaults: { ...defaults, school: school._id },
      schema: object({
        username: string().required(),
        competition: string().required(),
        ...(!student ? {
          password: string().required(),
        } : {}),
        schoolClass: object({
          title: string().required(),
          grade: string().required(),
        }),
      }),
      stored: student ? {
        ...student,
        school: student.school._id,
        schoolClass: pick(
          student.schoolClass,
          Object.keys(defaults.schoolClass),
        ),
      } : undefined,
      api: 'api/core/users/students',
      onSubmit: (v) => omit(v, !v.password ? 'password' : null),
    }}
  >

    <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
      AUTHENTICATION
    </h6>
    <div className="form-group">
      <label>Active</label>
      <FormCheckGroup
        name="active"
        type="checkbox"
        label=""
        asSwitch
      />
    </div>
    <div className="form-row">
      <div className="col">
        <FormGroup name="username" />
      </div>
      <div className="col">
        <FormGroup
          name="password"
          type="password"
          placeholder={
            student ? 'Leave this blank to keep the stored password' : ''
          }
        />
      </div>
    </div>

    <FieldsCompPicker />

    <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
      STUDENT INFO
    </h6>
    <FormGroup name="studentId" label="Class No." />
    <div className="form-row">
      <div className="col">
        <FormGroup name="name.full.zhhk" label="Name (Chinese)" />
      </div>
      <div className="col">
        <FormGroup name="name.full.en" label="Name (English)" />
      </div>
    </div>

    <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
      SCHOOL CLASS
    </h6>
    <div className="form-row">
      <div className="col">
        <FormGroup
          name="schoolClass.title"
          label="Class"
        />
      </div>
      <div className="col">
        <FormGroup
          name="schoolClass.grade"
          as="select"
          label="Grade"
        >
          <option value=""> - </option>
          {Object.keys(env.grades)
            .filter((key) => (
              (school.stage === 'p' && key <= 6)
              || (school.stage === 's' && key > 6)
            ))
            .map((key) => (
              <option value={key} key={key}>
                {env.grades[key].zhhk}
              </option>
            ))
          }
        </FormGroup>
      </div>
    </div>
  </FormResource>
);

export default FormStudent;
